@import 'abstract/colors';
@import 'abstract/variables';

login-sidebar {
  .popup {
    &-login {
      display: flex;
      flex-direction: column;
      width: 640px;
      max-width: 100%;
      height: 100%;
      background: #fff;
      position: relative;
      margin: 0;

      &__content {
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        gap: 20px;

        &--otp-password_tab {
          ul {
            max-width: 430px;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;

            li {
              font-weight: 400;
              font-size: 16px;
              line-height: 24px;
              padding: 8px 24px;
              text-align: center;
              width: 50%;
              color: $dark-blue;
              cursor: pointer;

              &.active {
                font-weight: 700;
                border-bottom: 2px solid $blue;
              }
            }
          }
        }
      }

      &-main {
        min-height: 350px;
        margin: unset;
        padding: 0 15px;
        box-sizing: border-box;
      }
      &-bottom {
        padding: 20px;
        border-top: 1px solid $sky-blue;
        &-title {
          font-size: 20px;
          text-align: center;
          margin: 0;
        }
      }
      &-contacts {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        @include breakpoint(sm) {
          flex-direction: column;
          text-align: center;
          line-height: 22px;
          margin-top: 10px;
        }
        a {
          color: $main;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
        }
      }
    }
  }
}
